import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { getChunkAPI } from './Chunk';
import Loading from '../Loading';
import toast from '../Toast';
import IconVideo from '../../../common/elements/static/IconVideo.svg';
import ProgressBar from '../ProgressBar';
import { COLOR } from '../Const';
import Multilingual from '../../Multilingual';
import { sum } from 'ramda';

const StyledDiv = styled.div`
  ${(props) => (!props.defaultIcon ? '' : `background-color: ${COLOR.primary};`)}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .upload-btn {
    width: ${(props) => props.size};
    height: 100%;
    object-fit: contain;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  }

  .loading {
    background-color: #00000080;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

const maxSize = 1024 * 1024 * 25; // 25MB

const UploadVideos = ({ className = '', multi = false, size = '1.5rem', customBtn, onChange = () => {} }) => {
  const [loading, setLoading] = useState(false);
  const [completed, setCompleted] = useState(0);

  const triggerFileInput = useRef();
  const [refreshInput, setRefreshInput] = useState(0);

  const uploadVideos = (videoFiles) => {
    const uploadedVideos = [];
    const videoProgress = [];

    const showProgressCompleted = () => {
      if (videoFiles.length === 0) {
        return;
      }

      setCompleted(((sum(videoProgress) * 100 * 0.9) / videoFiles.length).toFixed(1));
    };

    const callbackCheck = () => {
      if (uploadedVideos.length !== videoFiles.length) {
        return;
      }
      onChange([...uploadedVideos]);
      setLoading(false);
      setRefreshInput((pre) => pre + 1);
    };

    videoFiles.forEach((file, fileIndex) => {
      const chunkAPI = getChunkAPI(file);
      chunkAPI.uploadFile(
        (videoResult) => {
          if (videoResult === false) {
            toast(Multilingual(`ERROR.UNKNOWN`), { status: 'error', second: 2 });
            setLoading(false);
            setRefreshInput((pre) => pre + 1);
            return;
          }

          uploadedVideos.push(videoResult);
          callbackCheck();
        },
        (progress) => {
          videoProgress[fileIndex] = progress;
          showProgressCompleted();
        },
      );
    });
    callbackCheck();
  };

  const handleFileOnChange = (e) => {
    e.preventDefault();
    if (e.target.files.length === 0) {
      return;
    }

    setLoading(true);
    setCompleted(0);

    const videoFiles = [];
    let videoAmount = 1;
    let videoDone = 0;
    const inspectionDone = () => {
      videoDone++;
      if (videoDone < videoAmount) {
        return;
      }
      uploadVideos(videoFiles);
    };

    for (let file of e.target.files) {
      const { type, size } = file;
      const fileType = type.split('/')[0];
      if (fileType !== 'video') {
        continue;
      }

      if (size > maxSize) {
        toast(Multilingual(`ERROR.FILE_TOO_LARGE`), { status: 'error', second: 5 });
        continue;
      }

      videoAmount++;
      videoFiles.push(file);
      inspectionDone();
    }
    inspectionDone();
  };

  const uploadBtnOnClick = (e) => {
    e.preventDefault();
    triggerFileInput.current.click();
  };

  return (
    <StyledDiv className={className} defaultIcon={!customBtn} size={size}>
      {/* 真實的fileupload input */}
      <input
        key={refreshInput}
        type="file"
        accept="video/*"
        multiple={multi}
        style={{ display: 'none' }}
        ref={triggerFileInput}
        onChange={handleFileOnChange}
      />
      {/* 檔案上傳按鈕 */}
      {!customBtn ? (
        <img className="upload-btn" onClick={uploadBtnOnClick} src={IconVideo} alt="" />
      ) : (
        <>{customBtn(uploadBtnOnClick)}</>
      )}
      {loading && (
        <div className="loading">
          <Loading width={size} />
          <ProgressBar
            isOpen={true}
            completed={completed}
            title={parseFloat(completed) <= 89 ? '' : Multilingual(`FILE_TRANSFORMING`)}
          />
        </div>
      )}
    </StyledDiv>
  );
};

export default UploadVideos;
